import { render, staticRenderFns } from "./Form1099NECPreparations.vue?vue&type=template&id=57ad9530&scoped=true&"
import script from "./Form1099NECPreparations.vue?vue&type=script&lang=ts&"
export * from "./Form1099NECPreparations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ad9530",
  null
  
)

export default component.exports